import React, {useState, useEffect} from "react";
import {useObserver} from "mobx-react-lite";
import {useHistory} from "react-router-dom";
import {
    Col,
    Row,
    Table,
    Tag,
    Badge,
    Upload,
    message,
    DatePicker,
    Tooltip,
    Divider,
    Collapse
} from "antd";
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    DownloadOutlined,
    FileSearchOutlined,
    InfoCircleOutlined,
    PlusOutlined,
    SearchOutlined,
    UploadOutlined
} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {CaretUpOutlined, CaretDownOutlined} from "@ant-design/icons";

import {useStore} from "../../hooks/useStore";
import {useFetch} from "../../hooks/useFetch";
import {SelectField, CloseIcon, OptionsRow, ColIcon, SearchInput} from "./courierPageStyles";
import {formatPhoneNumber, isConstantExist, getConstant, b64DecodeToUrl} from "../../utils/helpers";
import {
    courierTypes,
    regionList,
    cities,
    courierStatusColors,
    activityColors,
    mapCourierStatuses,
    onboardingStatuses,
    onboardingSubStatuses,
    courierCallStatusMap
} from "../../constants/constants";
import {CustomButton} from "../_defaultComponents/CustomButton/CustomButton";
import {useWindowSize} from "../../hooks/useWindowSize";
import {
    CityFilter,
    CourierWalletOwnershipFilter,
    MotorTypeFilter,
    DrivingLicenseFilter,
    PoolFilter
} from "../_defaultComponents/FilterComponents";
import config from "../../_core/config";
import moment from "moment";
import {TableContainer} from "./ComponentStyles";
import DistrictFilter from "../_defaultComponents/FilterComponents/DistrictFilter";
import {EmptyMessage} from "../_defaultComponents/EmptyMessage/EmptyMessage";
import {useCourierOnboarding} from "hooks/useCourierOnboarding";

const {Column} = Table;

export const CourierPage = () => {
    const history = useHistory();
    const stores = useStore();
    const windowSize = useWindowSize();
    const {t} = useTranslation([
        "courierPage",
        "courierTypes",
        "mapCourierStatuses",
        "onboardingStatuses",
        "onboardingSubStatuses"
    ]);
    const {renderOnboardingStatus, renderOnboardingSubStatus} = useCourierOnboarding();
    const [open, setOpen] = useState(true);
    const [activity, setActivity] = useState("all");
    const [types, setTypes] = useState([]);
    const [regions, setRegion] = useState([]);
    //const [statuses, setStatuses] = useState([]);
    const [onboardingStatus, setOnboardingStatus] = useState("all");
    const [onboardingSubStatus, setOnboardingSubStatus] = useState("all");
    const [isApplicationRejected, setIsApplicationRejected] = useState(undefined);
    //const [poolId, setPoolId] = useState("all");
    const [city, setCity] = useState(stores.meStore.map.filters.city);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [vehicleInfo, setVehicleInfo] = useState("");
    const [vehicleInfoText, setVehicleInfoText] = useState("");
    const [tckn, setTckn] = useState("");
    const [tcknText, setTcknText] = useState("");
    const [tcknError, setTcknError] = useState("");
    const [text, setText] = useState("");
    const [call, setCall] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [sort, setSort] = useState(["createdAt_desc"]);
    //const [preferredCity, setPreferredCity] = useState("");
    const [district, setDistrict] = useState("");
    const [preferredDistrict, setPreferredDistrict] = useState("");
    const [loadingExcelData, setLoadingExcelData] = useState(false);
    const defaultDateRange = [moment().subtract(180, "days"), moment()];
    const [selectedDateRange, setSelectedDateRange] = useState(defaultDateRange);
    const [walletOwnershipFilter, setWalletOwnershipFilter] = useState("all");
    const [vehicleInfoError, setVehicleInfoError] = useState("");
    const [callStatuses, setCallStatuses] = useState(["all"]);
    const [callStatus, setCallStatus] = useState("all");
    const [motorTypeId, setMotorTypeId] = useState(undefined);
    const [drivingLicenseId, setDrivingLicenseId] = useState(undefined);
    const [loading, data, setData, setLoading] = useFetch({
        fetchFn: stores.courierStore.getCourierList.bind(null, {
            limit: 10,
            skip: (currentPage - 1) * 10,
            regions,
            //statuses,
            city,
            //preferredCity: preferredCity || undefined,
            types,
            searchText,
            vehicleInfo: vehicleInfoText,
            tckn: tcknText,
            activity,
            sort,
            onboardingStatus,
            onboardingSubStatus,
            isApplicationRejected,
            //poolId,
            district: district || undefined,
            preferredDistrict: preferredDistrict || undefined,
            startDate:
                Array.isArray(selectedDateRange) &&
                selectedDateRange.length === 2 &&
                selectedDateRange[0] &&
                selectedDateRange[1]
                    ? moment(selectedDateRange[0]).format("YYYY-MM-DD")
                    : undefined,
            endDate:
                Array.isArray(selectedDateRange) &&
                selectedDateRange.length === 2 &&
                selectedDateRange[0] &&
                selectedDateRange[1]
                    ? moment(selectedDateRange[1]).format("YYYY-MM-DD")
                    : undefined,
            walletOwnership: walletOwnershipFilter || "all",
            callStatus: callStatus,
            motorTypeId: motorTypeId || undefined,
            drivingLicenseId: drivingLicenseId || undefined
        }),
        dependencies: [
            currentPage,
            types,
            //statuses,
            city,
            //preferredCity,
            regions,
            searchText,
            vehicleInfo,
            tckn,
            call,
            activity,
            sort,
            onboardingStatus,
            onboardingSubStatus,
            isApplicationRejected,
            //poolId,
            district,
            preferredDistrict,
            selectedDateRange,
            walletOwnershipFilter,
            callStatus,
            motorTypeId,
            drivingLicenseId
        ],
        initialCall: false
    });
    useEffect(() => {
        const urlSearchParams = new URLSearchParams(history.location.search);
        const urlPage = urlSearchParams.get("page");
        const urlActivity = urlSearchParams.get("activity");
        let urlTypes = urlSearchParams.get("types");
        let urlRegions = urlSearchParams.get("regions");
        //let urlStatuses = urlSearchParams.get("statuses");
        const urlCity = urlSearchParams.get("city");
        //const urlPreferredCity = urlSearchParams.get("preferredCity");
        const urlSearchText = urlSearchParams.get("searchText");
        const urlOnboardingStatus = urlSearchParams.get("onboardingStatus");
        const urlOnboardingSubStatus = urlSearchParams.get("onboardingSubStatus");
        const urlIsApplicationRejected = urlSearchParams.get("isApplicationRejected");
        //const urlPoolId = urlSearchParams.get("poolId");
        const urlWalletOwnership = urlSearchParams.get("walletOwnership");
        const urlCallStatus = urlSearchParams.get("callStatus");
        const urlMotorTypeId = urlSearchParams.get("motorTypeId");
        const urlDrivingLicenseId = urlSearchParams.get("drivingLicenseId");
        if (urlPage) {
            const page = parseInt(urlPage);
            if (!isNaN(page)) setCurrentPage(page);
        }
        if (urlActivity) {
            setActivity(urlActivity);
        }
        if (urlTypes) {
            urlTypes = urlTypes.split("-");
            const notValid = urlTypes.find(ty => !isConstantExist(courierTypes, ty));
            if (!notValid) {
                setTypes(urlTypes);
            }
        }
        if (urlRegions) {
            urlRegions = urlRegions.split("-");
            const notValid = urlRegions.find(reg => !isConstantExist(regionList, reg));
            if (!notValid) {
                setRegion(urlRegions);
            }
        }
        /*  if (urlStatuses) {
            urlStatuses = urlStatuses.split("-");
            const notValid = urlStatuses.find(st => !isConstantExist(mapCourierStatuses, st));
            if (!notValid) {
                setStatuses(urlStatuses);
            }
        } */
        if (urlCity) {
            if (isConstantExist(cities, urlCity)) {
                setCity(urlCity);
            }
        }
        /* if (urlPreferredCity) {
            setPreferredCity(urlPreferredCity);
        } */
        if (urlSearchText) {
            setSearchText(urlSearchText);
            setText(urlSearchText);
        }
        if (urlWalletOwnership) {
            setWalletOwnershipFilter(urlWalletOwnership);
        }
        if (urlOnboardingStatus) {
            if (isConstantExist(onboardingStatuses, urlOnboardingStatus)) {
                setOnboardingStatus(urlOnboardingStatus);
            }
        }
        if (urlOnboardingSubStatus) {
            if (isConstantExist(onboardingSubStatuses, urlOnboardingSubStatus)) {
                setOnboardingSubStatus(urlOnboardingSubStatus);
            }
        }
        /* if (urlPoolId) {
            setPoolId(urlPoolId);
        } */
        if (urlCallStatus) {
            setCallStatus(urlCallStatus);
        }
        if (urlIsApplicationRejected) {
            setIsApplicationRejected(urlIsApplicationRejected === "true" ? true : undefined);
        }
        if (urlMotorTypeId) {
            setMotorTypeId(urlMotorTypeId);
        }
        if (urlDrivingLicenseId) {
            setDrivingLicenseId(urlDrivingLicenseId);
        }
        setCall(!call);
    }, []);

    useEffect(() => {
        const fetchCallStatuses = async () => {
            try {
                const result = await stores.courierStore.getCourierCallStatuses();
                setCallStatuses(result?.result || []);
            } catch (err) {
                console.error("Call statuses could not be fetched:", err);
            }
        };

        fetchCallStatuses();
    }, []);

    useEffect(() => {
        setUrl();
    }, [
        currentPage,
        types,
        //statuses,
        regions,
        city,
        //preferredCity,
        searchText,
        vehicleInfo,
        tckn,
        activity,
        onboardingStatus,
        onboardingSubStatus,
        isApplicationRejected,
        //poolId,
        walletOwnershipFilter,
        callStatus,
        motorTypeId,
        drivingLicenseId
    ]);

    useEffect(() => {
        if (windowSize.width < 768) {
            setOpen(false);
        }
    }, [windowSize.width, open]);

    const newCourier = async event => {
        event.preventDefault();
        await stores.appStore.setLoading(true);
        history.push("/couriers/new");
        await stores.appStore.setLoading(false);
    };

    const setUrl = () => {
        let path = history.location.pathname;
        if (currentPage) {
            path += "?page=" + currentPage;
        }
        if (activity) {
            path += "&activity=" + activity;
        }
        if (types.length) {
            path += "&types=" + types.join("-");
        }
        /* if (statuses.length) {
            path += "&statuses=" + statuses.join("-");
        } */
        if (regions.length) {
            path += "&regions=" + regions.join("-");
        }
        if (city) {
            path += "&city=" + city;
        }
        /*  if (preferredCity) {
            path += "&preferredCity=" + preferredCity;
        } */
        if (searchText) {
            path += "&searchText=" + searchText;
        }
        if (vehicleInfo) {
            path += "&vehicleInfo=" + vehicleInfo;
        }
        if (tckn) {
            path += "&tckn=" + tckn;
        }
        if (walletOwnershipFilter) {
            path += "&walletOwnership=" + walletOwnershipFilter;
        }
        if (onboardingStatus) {
            path += "&onboardingStatus=" + onboardingStatus;
        }
        if (onboardingSubStatus) {
            path += "&onboardingSubStatus=" + onboardingSubStatus;
        }
        if (isApplicationRejected) {
            path += "&isApplicationRejected=" + isApplicationRejected;
        }
        if (callStatus) {
            path += "&callStatus=" + callStatus;
        }
        /* if (poolId) {
            path += "&poolId=" + poolId;
        } */
        if (motorTypeId) {
            path += "&motorTypeId=" + motorTypeId;
        }
        if (drivingLicenseId) {
            path += "&drivingLicenseId=" + drivingLicenseId;
        }
        history.push(path);
    };

    const fileUploadProps = {
        name: "file",
        multiple: false,
        showUploadList: false,
        beforeUpload: file => {
            setFileList([...fileList, file]);
        },
        customRequest: () => {
            setLoading(true);
            const formData = new FormData();
            fileList.forEach(file => {
                formData.append("files[]", file);
            });
            fetch(`${config.getBasePublicUrl()}api/panel/v1/courier/import`, {
                method: "POST",
                headers: {
                    Authorization: "Basic " + stores.meStore.sessionToken
                },
                body: formData
            })
                .then(res => res.json())
                .then(async res => {
                    if (res.result.isSuccess == false) {
                        message.error(
                            t("modal.fileUpload.error", {
                                ns: "courierPage",
                                filename: fileList[0].name,
                                responseMessage: res.result.message,
                                duration: 10000
                            })
                        );
                        return;
                    } else {
                        setFileList([]);
                        const responseMessages = [];

                        if (res.result.createdCouriers.length > 0) {
                            const actionText = t("import.messages.created", {ns: "courierPage"});
                            const msg = `${res.result.createdCouriers.length} ${actionText}`;
                            responseMessages.push(<div key={msg}>{msg}</div>);
                        }
                        if (res.result.updatedCouriers.length > 0) {
                            const actionText = t("import.messages.updated", {ns: "courierPage"});
                            const msg = `${res.result.updatedCouriers.length} ${actionText}`;
                            responseMessages.push(<div key={msg}>{msg}</div>);
                        }
                        if (res.result.skippedCouriers.length > 0) {
                            const actionText = t("import.messages.skipped", {ns: "courierPage"});
                            const msg = `${res.result.skippedCouriers.length} ${actionText}`;
                            responseMessages.push(<div key={msg}>{msg}</div>);
                        }
                        if (res.result.geocodedCouriers.length > 0) {
                            const actionText = t("import.messages.geocoded", {ns: "courierPage"});
                            const msg = `${res.result.geocodedCouriers.length} ${actionText}`;
                            responseMessages.push(<div key={msg}>{msg}</div>);
                        }
                        const validationMessages = res.result.validationMessages;
                        let errorExcel = res.result.errorExcel;
                        if (errorExcel) {
                            responseMessages.push(
                                <div key={"error"}>
                                    <b>
                                        {t("modal.fileUpload.errorExcel", {
                                            ns: "courierPage"
                                        })}
                                    </b>
                                </div>
                            );
                            errorExcel = await b64DecodeToUrl(errorExcel);
                            let link = document.createElement("a");
                            link.href = errorExcel;
                            link.download = `${t("screens.couriers", {ns: "common"})}.xlsx`;
                            document.body.appendChild(link);
                            link.click();
                            setTimeout(function() {
                                window.URL.revokeObjectURL(link);
                            }, 200);
                        }

                        for (const message of validationMessages) {
                            responseMessages.push(<div key={message}>{message}</div>);
                        }
                        stores.appStore.openSuccessModal({
                            title: t("modal.fileUpload.success", {ns: "courierPage"}),
                            content: responseMessages
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                    message.error(t("modal.fileUpload.uploadFailed", {ns: "courierPage"}));
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };
    const courierSeniority = jobStartDate => {
        const year = moment().diff(moment(jobStartDate), "years");
        const month = moment().diff(moment(jobStartDate), "months") - year * 12;
        if (jobStartDate === null) return "-";
        if (year === 0 && month === 0) {
            return 0 + " " + t("units.month.long", {ns: "common"});
        }
        if (year === 0) {
            return month + " " + t("units.month.long", {ns: "common"});
        }
        if (month === 0) {
            return year + " " + t("units.year.long", {ns: "common"});
        }
        return (
            year +
            " " +
            t("units.year.long", {ns: "common"}) +
            " " +
            month +
            " " +
            t("units.month.long", {ns: "common"})
        );
    };
    const getExcelTemplateData = async () => {
        setLoadingExcelData(true);
        try {
            const response = await stores.courierStore.getCourierList({
                limit: 10,
                skip: (currentPage - 1) * 10,
                regions,
                //statuses,
                city,
                //preferredCity: preferredCity || undefined,
                types,
                searchText,
                vehicleInfo,
                tckn,
                walletOwnership: walletOwnershipFilter,
                activity,
                sort,
                onboardingStatus,
                onboardingSubStatus,
                isApplicationRejected,
                //poolId,
                district: district || undefined,
                preferredDistrict: preferredDistrict || undefined,
                startDate:
                    Array.isArray(selectedDateRange) && selectedDateRange.length == 2
                        ? moment(selectedDateRange[0]).format("YYYY-MM-DD")
                        : undefined,
                endDate:
                    Array.isArray(selectedDateRange) && selectedDateRange.length == 2
                        ? moment(selectedDateRange?.[1]).format("YYYY-MM-DD")
                        : undefined,
                excel: true,
                callStatus: callStatus,
                motorTypeId: motorTypeId || undefined,
                drivingLicenseId: drivingLicenseId || undefined
            });
            const base64Data = response?.base64Excel;
            const blobUrl = await b64DecodeToUrl(base64Data);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", "courierList.xlsx");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.log("error", error);
        } finally {
            setLoadingExcelData(false);
        }
    };

    const handleDateChange = value => {
        setCurrentPage(1);
        if (!value || value.length === 0) {
            setSelectedDateRange([]);
        } else {
            setSelectedDateRange(value);
        }
    };

    const validateTCKN = value => {
        // Remove any non-numeric characters
        const numericValue = value.replace(/\D/g, "");

        if (numericValue.length > 11) {
            return false;
        }

        if (numericValue.length === 11) {
            // TCKN validation algorithm
            let digits = numericValue.split("").map(Number);

            // First digit cannot be 0
            if (digits[0] === 0) return false;

            // 10th digit validation
            let odd = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
            let even = digits[1] + digits[3] + digits[5] + digits[7];
            let digit10 = (odd * 7 - even) % 10;

            // 11th digit validation
            let sum = digits.slice(0, 10).reduce((acc, val) => acc + val, 0);
            let digit11 = sum % 10;

            return digit10 === digits[9] && digit11 === digits[10];
        }

        return true;
    };

    const validateLicensePlate = value => {
        // Türkiye plaka formatı kontrolü
        const plateRegex = /^([0-8][0-9]|9[0-1])\s*[A-Z]{1,3}\s*[0-9]{2,4}$/;

        // Boşlukları kaldır
        const cleanValue = value.replace(/\s/g, "");

        // İl kodu kontrolü (01-81 arası)
        const cityCode = parseInt(cleanValue.substring(0, 2));
        if (cityCode < 1 || cityCode > 81) {
            return false;
        }

        // Özel durumlar için kontrol
        const specialPlates = ["AAA", "M", "A"]; // Özel plakalar için kontrol

        // Plaka formatı kontrolü
        if (!plateRegex.test(cleanValue)) {
            return false;
        }

        // Harf kısmını al
        const letters = cleanValue.match(/[A-Z]{1,3}/)[0];

        // Özel plaka kontrolü
        if (letters === "AAA" && cleanValue.length !== 9) {
            return false;
        }

        // Resmi araç veya geçici plaka kontrolü
        if ((letters === "A" || letters === "M") && cleanValue.length !== 8) {
            return false;
        }

        return true;
    };

    const toggleSortField = field => {
        setSort(prevSort => {
            const existingIndex = prevSort.findIndex(s => s.startsWith(`${field}_`));
            const newSort = [...prevSort];

            if (existingIndex === -1) {
                // default → asc
                newSort.push(`${field}_asc`);
            } else {
                const [_, direction] = newSort[existingIndex].split("_");
                if (direction === "asc") {
                    // asc → desc
                    newSort[existingIndex] = `${field}_desc`;
                } else if (direction === "desc") {
                    // desc → default
                    newSort.splice(existingIndex, 1);
                }
            }

            return newSort;
        });
    };

    const getSortIcon = field => {
        const sortField = sort.find(s => s.startsWith(`${field}_`));
        if (sortField?.includes("asc")) {
            return <CaretUpOutlined />;
        }
        if (sortField?.includes("desc")) {
            return <CaretDownOutlined />;
        }
        return <span style={{marginLeft: 5, opacity: 0.3}}>⇅</span>;
    };

    const renderCallStatusOptions = ({callStatuses}) => {
        return callStatuses?.map(status => (
            <SelectField.Option key={status} value={status}>
                {t(`callStatuses.${status}`, {
                    ns: "common",
                    defaultValue: status
                })}
            </SelectField.Option>
        ));
    };

    const resetFilters = () => {
        setSelectedDateRange([]);
        setCurrentPage(1);
        setActivity("all");
        setTypes([]);
        //setStatuses([]);
        setCity(undefined);
        setMotorTypeId(undefined);
        setDrivingLicenseId(undefined);
    };
    return useObserver(() => (
        <div data-testid="courierScreen">
            <OptionsRow justify="space-between" data-testid="filterCard">
                <Col span={24}>
                    <Row type="flex" style={{rowGap: "5px", columnGap: "5px"}}>
                        <Row
                            type="flex"
                            style={{
                                rowGap: "5px",
                                columnGap: "5px",
                                width: "100%",
                                marginBottom: "8px"
                            }}
                            justify="space-between"
                        >
                            <Col span={24} xxs={24} sm={16} md={12} lg={6} xl={5}>
                                <h5>
                                    Başvuru Tarihi{" "}
                                    <Tooltip title="Son 30 gün içerisinde başvuranları gösterir.">
                                        <InfoCircleOutlined />
                                    </Tooltip>
                                </h5>
                                <DatePicker.RangePicker
                                    style={{width: "100%"}}
                                    placeholder={["Başlangıç Tarihi", "Bitiş Tarihi"]}
                                    onChange={handleDateChange}
                                    value={
                                        selectedDateRange && selectedDateRange.length === 2
                                            ? selectedDateRange
                                            : undefined
                                    }
                                    allowClear
                                />
                            </Col>
                            <Col xs={24} sm={16} md={12} lg={4} xl={4} span={4}>
                                <CityFilter
                                    allowClear={true}
                                    selectMarginBottom={"0px"}
                                    value={city}
                                    onChange={value => {
                                        setCurrentPage(1);
                                        setCity(value);
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={16} md={12} lg={4} xl={4} span={4}>
                                <DistrictFilter
                                    allowClear={true}
                                    selectMarginBottom={"0px"}
                                    city={city}
                                    disabled={!city}
                                    value={district}
                                    onChange={value => {
                                        setCurrentPage(1);
                                        setDistrict(value);
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={16} md={12} lg={3} xl={4} span={4}>
                                <h5>Çalışmak İstenen İlçe</h5>
                                <DistrictFilter
                                    allowClear={true}
                                    selectMarginBottom={"0px"}
                                    city={city}
                                    disabled={!city}
                                    value={preferredDistrict}
                                    showLabel={false}
                                    onChange={value => {
                                        setCurrentPage(1);
                                        setPreferredDistrict(value);
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={16} md={12} lg={3} xl={3} span={4}>
                                <MotorTypeFilter
                                    style={{marginBottom: "0px"}}
                                    allowClear={true}
                                    value={motorTypeId}
                                    onChange={value => {
                                        setCurrentPage(1);
                                        setMotorTypeId(value);
                                    }}
                                />
                            </Col>
                            <Col xs={24} sm={16} md={12} lg={3} xl={3} span={4}>
                                <DrivingLicenseFilter
                                    style={{marginBottom: "0px"}}
                                    allowClear={true}
                                    value={drivingLicenseId}
                                    onChange={value => {
                                        setCurrentPage(1);
                                        setDrivingLicenseId(value);
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row
                            type="flex"
                            style={{
                                rowGap: "5px",
                                columnGap: "5px",
                                width: "100%",
                                marginBottom: "8px"
                            }}
                            justify="space-between"
                        >
                            {stores.meStore.checkRole("notVisibleForCompanyUser") && (
                                <Col
                                    xs={24}
                                    sm={16}
                                    md={12}
                                    lg={6}
                                    xl={6}
                                    span={6}
                                    style={{width: "100%"}}
                                >
                                    <h5>{t("fields.courierActivity", {ns: "common"})}</h5>
                                    <SelectField
                                        allowClear={true}
                                        style={{marginBottom: "0px"}}
                                        value={activity}
                                        data-testid="courierActivity"
                                        onChange={value => {
                                            setCurrentPage(1);
                                            setActivity(value);
                                        }}
                                    >
                                        <SelectField.Option
                                            value="all"
                                            data-testid="courierActivity_option"
                                        >
                                            {t("filters.all", {ns: "common"})}
                                        </SelectField.Option>
                                        <SelectField.Option
                                            value="enabled"
                                            data-testid="courierActivity_option"
                                        >
                                            {t("courierActivityStatuses.activeCouriers", {
                                                ns: "courierPage"
                                            })}
                                        </SelectField.Option>
                                        <SelectField.Option
                                            value="disabled"
                                            data-testid="courierActivity_option"
                                        >
                                            {t("courierActivityStatuses.inactiveCouriers", {
                                                ns: "courierPage"
                                            })}
                                        </SelectField.Option>
                                    </SelectField>
                                </Col>
                            )}
                            <Col
                                xs={24}
                                sm={16}
                                md={12}
                                lg={6}
                                xl={6}
                                span={6}
                                style={{width: "100%"}}
                            >
                                <h5>{t("fields.courierType", {ns: "common"})}</h5>
                                <SelectField
                                    allowClear={true}
                                    style={{marginBottom: "0px"}}
                                    optionFilterProp="label"
                                    value={types}
                                    onChange={value => {
                                        setCurrentPage(1);
                                        setTypes(value);
                                    }}
                                    mode="multiple"
                                    placeholder={t("filters.addFilter", {ns: "common"})}
                                    data-testid="courierTypes"
                                >
                                    {courierTypes.map(ty => (
                                        <SelectField.Option
                                            key={ty.value}
                                            value={ty.value}
                                            label={t(ty.translation_key, {ns: "courierTypes"})}
                                            data-testid="courierTypes_option"
                                        >
                                            {t(ty.translation_key, {ns: "courierTypes"})}
                                        </SelectField.Option>
                                    ))}
                                </SelectField>
                            </Col>
                            <Col
                                xs={24}
                                sm={16}
                                md={12}
                                lg={6}
                                xl={6}
                                span={6}
                                style={{width: "100%"}}
                            >
                                <h5>{t("fields.onboardingStatus", {ns: "common"})}</h5>
                                <SelectField
                                    allowClear={true}
                                    style={{marginBottom: "0px"}}
                                    optionFilterProp="label"
                                    value={
                                        onboardingStatus === "all" && isApplicationRejected
                                            ? "isApplicationRejected"
                                            : onboardingStatus
                                    }
                                    onChange={value => {
                                        setCurrentPage(1);
                                        if (value === "isApplicationRejected") {
                                            setIsApplicationRejected(true);
                                            setOnboardingStatus("all");
                                        } else {
                                            setOnboardingStatus(value);
                                            setIsApplicationRejected(undefined);
                                        }
                                    }}
                                    placeholder={t("filters.addFilter", {ns: "common"})}
                                    data-testid="onboardingStatus"
                                >
                                    {onboardingStatuses.map(oStatus => (
                                        <SelectField.Option
                                            key={oStatus.value}
                                            value={oStatus.value}
                                            label={t(oStatus.translation_key, {
                                                ns: "onboardingStatuses"
                                            })}
                                            data-testid="courierStatus_options"
                                        >
                                            {t(oStatus.translation_key, {ns: "onboardingStatuses"})}
                                        </SelectField.Option>
                                    ))}
                                    <SelectField.Option
                                        value="isApplicationRejected"
                                        label="Olumsuz"
                                    >
                                        {"Olumsuz"}
                                    </SelectField.Option>
                                </SelectField>
                            </Col>
                            <Col
                                xs={24}
                                sm={16}
                                md={12}
                                lg={5}
                                xl={5}
                                span={5}
                                style={{width: "100%"}}
                            >
                                <h5>İşe Alım Alt Durumu</h5>
                                <SelectField
                                    allowClear={true}
                                    style={{marginBottom: "0px"}}
                                    optionFilterProp="label"
                                    value={onboardingSubStatus}
                                    onChange={value => {
                                        setCurrentPage(1);
                                        setOnboardingSubStatus(value);
                                    }}
                                    placeholder={t("filters.addFilter", {ns: "common"})}
                                    data-testid="onboardingStatus"
                                >
                                    {onboardingSubStatuses
                                        .filter(oStatus => oStatus.translation_key !== "noStatus")
                                        .map(oStatus => (
                                            <SelectField.Option
                                                key={oStatus.value}
                                                value={oStatus.value}
                                                label={t(oStatus.translation_key, {
                                                    ns: "onboardingSubStatuses"
                                                })}
                                                data-testid="courierSubStatus_options"
                                            >
                                                {t(oStatus.translation_key, {
                                                    ns: "onboardingSubStatuses"
                                                })}
                                            </SelectField.Option>
                                        ))}
                                </SelectField>
                            </Col>
                        </Row>
                        {/* <Col xs={24} sm={16} md={12} lg={8} xl={5} span={4}>
                            {" "}
                            <h5>{t("fields.courierStatus", {ns: "common"})}</h5>
                            <SelectField
                                optionFilterProp="label"
                                value={statuses}
                                onChange={value => {
                                    setCurrentPage(1);
                                    setStatuses(value);
                                }}
                                mode="multiple"
                                placeholder={t("filters.addFilter", {ns: "common"})}
                                data-testid="courierStatus"
                            >
                                {mapCourierStatuses.map(status => (
                                    <SelectField.Option
                                        key={status.value}
                                        value={status.value}
                                        label={t(status.translation_key, {
                                            ns: "mapCourierStatuses"
                                        })}
                                        data-testid="courierStatus_options"
                                    >
                                        {t(status.translation_key, {ns: "mapCourierStatuses"})}
                                    </SelectField.Option>
                                ))}
                            </SelectField>
                        </Col> */}
                        <Collapse style={{width: "100%", marginBottom: "8px"}}>
                            <Collapse.Panel header="Diğer Filtreler" key="other-filters">
                                <Row
                                    type="flex"
                                    style={{
                                        rowGap: "5px",
                                        columnGap: "5px",
                                        width: "100%"
                                    }}
                                    justify="space-between"
                                >
                                    <Col xs={24} sm={16} md={12} lg={6} xl={6} span={4}>
                                        <h5>{t("filters.searchWithTckn", {ns: "common"})}</h5>
                                        <SearchInput
                                            allowClear={true}
                                            value={tcknText}
                                            data-testid="searchInput"
                                            onSearch={value => {
                                                if (validateTCKN(value)) {
                                                    const normalizedValue = value.replace(
                                                        /\D/g,
                                                        ""
                                                    );
                                                    setCurrentPage(1);
                                                    setTckn(normalizedValue);
                                                    resetFilters();
                                                    setTcknError("");
                                                } else {
                                                    setTcknError(
                                                        "Lütfen geçerli bir TC Kimlik Numarası giriniz"
                                                    );
                                                }
                                            }}
                                            onChange={event => {
                                                const value = event.target.value;
                                                if (value.length <= 11 && /^\d*$/.test(value)) {
                                                    setCurrentPage(1);
                                                    setTcknText(value);
                                                    resetFilters();
                                                    setTcknError("");
                                                }
                                            }}
                                            enterButton={
                                                <CustomButton
                                                    data-testid="searchInput_searchButton"
                                                    icon={<SearchOutlined />}
                                                />
                                            }
                                            suffix={
                                                tckn ? (
                                                    <CloseIcon
                                                        data-testid="searchInput_deleteButton"
                                                        onClick={() => {
                                                            setCurrentPage(1);
                                                            setTckn("");
                                                            setTcknText("");
                                                            setTcknError("");
                                                        }}
                                                    />
                                                ) : (
                                                    <span />
                                                )
                                            }
                                        />
                                        {tcknError && (
                                            <div
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    marginTop: "4px"
                                                }}
                                            >
                                                {tcknError}
                                            </div>
                                        )}
                                    </Col>
                                    <Col xs={24} sm={16} md={12} lg={6} xl={6} span={4}>
                                        <h5>{t("filters.searchWithVehicle", {ns: "common"})}</h5>
                                        <SearchInput
                                            allowClear={true}
                                            value={vehicleInfoText}
                                            data-testid="searchInput"
                                            onSearch={value => {
                                                if (validateLicensePlate(value)) {
                                                    const normalizedValue = value
                                                        .toUpperCase()
                                                        .replace(/\s/g, "");
                                                    setCurrentPage(1);
                                                    setVehicleInfo(normalizedValue);
                                                    resetFilters();
                                                    setVehicleInfoError("");
                                                } else {
                                                    setVehicleInfoError(
                                                        "Lütfen geçerli bir plaka giriniz (Örn: 34ABC123, 34A1234, 34AAA0001)"
                                                    );
                                                }
                                            }}
                                            onChange={event => {
                                                const value = event.target.value.toUpperCase();
                                                if (
                                                    /^[A-Z0-9\s]*$/.test(value) &&
                                                    value.length <= 11
                                                ) {
                                                    setCurrentPage(1);
                                                    setVehicleInfoText(value);
                                                    resetFilters();
                                                    setVehicleInfoError("");
                                                }
                                            }}
                                            enterButton={
                                                <CustomButton
                                                    data-testid="searchInput_searchButton"
                                                    icon={<SearchOutlined />}
                                                />
                                            }
                                            suffix={
                                                vehicleInfo ? (
                                                    <CloseIcon
                                                        data-testid="searchInput_deleteButton"
                                                        onClick={() => {
                                                            setCurrentPage(1);
                                                            setVehicleInfo("");
                                                            setVehicleInfoText("");
                                                            setVehicleInfoError("");
                                                        }}
                                                    />
                                                ) : (
                                                    <span />
                                                )
                                            }
                                        />
                                        {vehicleInfoError && (
                                            <div
                                                style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    marginTop: "4px"
                                                }}
                                            >
                                                {vehicleInfoError}
                                            </div>
                                        )}
                                    </Col>
                                    <Col xs={24} sm={16} md={12} lg={6} xl={6} span={4}>
                                        <h5>{t("filters.search", {ns: "common"})}</h5>
                                        <SearchInput
                                            value={text}
                                            data-testid="searchInput"
                                            onSearch={value => {
                                                const normalizedValue = value
                                                    .toLowerCase()
                                                    .replace(/ğ/g, "g")
                                                    .replace(/ü/g, "u")
                                                    .replace(/ş/g, "s")
                                                    .replace(/ı/g, "i")
                                                    .replace(/ö/g, "o")
                                                    .replace(/ç/g, "c");
                                                setCurrentPage(1);
                                                setSearchText(normalizedValue);
                                            }}
                                            onChange={event => {
                                                setCurrentPage(1);
                                                setText(event.target.value);
                                            }}
                                            enterButton={
                                                <CustomButton
                                                    data-testid="searchInput_searchButton"
                                                    icon={<SearchOutlined />}
                                                />
                                            }
                                            suffix={
                                                text ? (
                                                    <CloseIcon
                                                        data-testid="searchInput_deleteButton"
                                                        onClick={() => {
                                                            setCurrentPage(1);
                                                            setSearchText("");
                                                            setText("");
                                                        }}
                                                    />
                                                ) : (
                                                    <span />
                                                )
                                            }
                                            placeholder={"İsim, Soyisim, Telefon"}
                                        />
                                    </Col>
                                    <Col xs={24} sm={16} md={12} lg={4} xl={5} span={4}>
                                        <h5>{t("fields.callStatus", {ns: "common"})}</h5>
                                        <SelectField
                                            allowClear={true}
                                            value={callStatus}
                                            onChange={value => {
                                                setCurrentPage(1);
                                                setCallStatus(value);
                                            }}
                                        >
                                            {renderCallStatusOptions({callStatuses})}
                                        </SelectField>
                                    </Col>
                                </Row>{" "}
                            </Collapse.Panel>
                        </Collapse>

                        {/* <Col xs={24} sm={16} md={12} lg={8} xl={4} span={4}>
                            <h5>Çalışmak İstenen Şehir</h5>
                            <CityFilter
                                showLabel={false}
                                value={preferredCity}
                                onChange={value => {
                                    setCurrentPage(1);
                                    setPreferredCity(value);
                                }}
                            />
                        </Col> */}

                        {/*  <Col xs={24} sm={16} md={12} lg={8} xl={4} span={4}>
                            <PoolFilter
                                value={poolId}
                                onChange={value => {
                                    setCurrentPage(1);
                                    setPoolId(value);
                                }}
                            />
                        </Col> */}
                        {/*  <Col xs={24} sm={16} md={12} lg={8} xl={4} span={4}>
                                <CourierWalletOwnershipFilter
                                    value={walletOwnershipFilter}
                                    onChange={value => {
                                        setCurrentPage(1);
                                        setWalletOwnershipFilter(value);
                                    }}
                                />
                            </Col> */}
                    </Row>
                    <Row align="center" justify="end">
                        <div>
                            <CustomButton
                                type="primary"
                                data-testid="exportWithExcelButton"
                                onClick={async () => {
                                    setLoadingExcelData(true);
                                    await getExcelTemplateData();
                                }}
                                loading={loadingExcelData}
                                icon={<DownloadOutlined />}
                            >
                                Excel Çıktısı İndir
                            </CustomButton>
                        </div>

                        {stores.meStore.checkRole("newCourier") && (
                            <>
                                <CustomButton
                                    data-testid="newCourierButton"
                                    href="/couriers/new"
                                    onClick={event => newCourier(event)}
                                    icon={<PlusOutlined />}
                                />

                                <Upload {...fileUploadProps} accept=".xlsx,.xls,.csv,.tsv">
                                    <CustomButton
                                        icon={<UploadOutlined />}
                                        data-testid="importFromExcelButton"
                                    >
                                        {t("actions.importFromExcel", {
                                            ns: "courierPage"
                                        })}
                                    </CustomButton>
                                </Upload>
                            </>
                        )}
                    </Row>
                </Col>
            </OptionsRow>
            <TableContainer
                small={open ? "medium" : "small"}
                loading={loading}
                dataSource={data.rows}
                rowKey="_id"
                data-testid="table"
                scroll={{x: "max-content"}}
                showExpandColumn
                pagination={{
                    total: data.dataCount,
                    current: currentPage,
                    showSizeChanger: false,
                    onChange: async page => {
                        setCurrentPage(page);
                        history.push("/couriers?page=" + page);
                    }
                }}
                style={{
                    marginTop: 16
                }}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                display={data?.rows?.length > 0 ? "grid" : "flex"}
                dataTitles={[
                    t("actions.detail", {ns: "common"}),
                    t("fields.courierStatus", {ns: "common"}),
                    "Başvuru Tarihi",
                    t("courierPageFields.seniority", {ns: "courierPage"}),
                    t("courierPageFields.fullname", {ns: "courierPage"}),
                    t("courierPageFields.cellphone", {ns: "courierPage"}),
                    t("courierPageFields.type", {ns: "courierPage"}),
                    t("courierPageFields.state", {ns: "courierPage"}),
                    t("fields.onboardingStatus", {ns: "common"}),
                    `İşe Alım Alt Durumu`,
                    "Cüzdan Durumu",
                    t("fields.lastCallDate", {ns: "common"})
                ]}
            >
                <Column
                    title={t("actions.detail", {ns: "common"})}
                    dataIndex="_id"
                    render={text => (
                        <CustomButton
                            href={"/couriers/" + text}
                            data-testid="courierDetailButton"
                            onClick={event => {
                                event.preventDefault();
                                window.open("/couriers/" + text, "_blank");
                            }}
                            icon={<FileSearchOutlined />}
                        />
                    )}
                />
                <ColIcon
                    title={t("fields.courierActivity", {ns: "common"})}
                    width={50}
                    dataIndex="disabled"
                    render={disabled => (
                        <>
                            {disabled ? (
                                <span style={{color: activityColors[!disabled]}}>
                                    {t("courierActivityStatuses.inactiveCouriers", {
                                        ns: "courierPage"
                                    })}
                                </span>
                            ) : (
                                <span style={{color: activityColors[!disabled]}}>
                                    {t("courierActivityStatuses.activeCouriers", {
                                        ns: "courierPage"
                                    })}
                                </span>
                            )}
                        </>
                    )}
                />
                <Column
                    title={
                        <button
                            type="button"
                            style={{
                                cursor: "pointer",
                                background: "none",
                                border: "none",
                                padding: 0,
                                font: "inherit",
                                color: "inherit",
                                display: "flex",
                                alignItems: "center"
                            }}
                            onClick={() => toggleSortField("createdAt")}
                        >
                            Başvuru Tarihi
                            {getSortIcon("createdAt")}
                        </button>
                    }
                    dataIndex="createdAt"
                    render={createdAt => (
                        <span>
                            {createdAt ? moment(createdAt).format("DD.MM.YYYY HH:mm") : "-"}
                        </span>
                    )}
                />
                <Column
                    title={
                        <button
                            type="button"
                            style={{
                                cursor: "pointer",
                                background: "none",
                                border: "none",
                                padding: 0,
                                font: "inherit",
                                color: "inherit",
                                display: "flex",
                                alignItems: "center"
                            }}
                            onClick={() => toggleSortField("jobStartDate")}
                        >
                            {t("courierPageFields.seniority", {ns: "courierPage"})}
                            {getSortIcon("jobStartDate")}
                        </button>
                    }
                    dataIndex="jobStartDate"
                    render={jobStartDate => (
                        <span data-testid="courierName">{courierSeniority(jobStartDate)}</span>
                    )}
                />
                <Column
                    title={t("courierPageFields.fullname", {ns: "courierPage"})}
                    dataIndex="fullname"
                    render={text => <span data-testid="courierName">{text}</span>}
                />
                <Column
                    title={t("courierPageFields.cellphone", {ns: "courierPage"})}
                    dataIndex="cellPhone"
                    render={text => (
                        <span data-testid="courierPhone">{formatPhoneNumber(text)}</span>
                    )}
                />
                <Column
                    title={t("courierPageFields.type", {ns: "courierPage"})}
                    dataIndex="type"
                    render={text => (
                        <Tag data-testid="courierType">
                            {isConstantExist(courierTypes, text)
                                ? t(getConstant(courierTypes, text).translation_key, {
                                      ns: "courierTypes"
                                  })
                                : "-"}
                        </Tag>
                    )}
                />
                <Column
                    title={t("courierPageFields.state", {ns: "courierPage"})}
                    dataIndex="state"
                    render={(text, record) => {
                        let statusValue = text.status;
                        if (text.deliveryState) {
                            statusValue = text.deliveryState;
                            if (text.deliveryState.includes("PickUp")) {
                                statusValue = "busyOnPickup";
                            }
                            if (text.deliveryState.includes("Delivery")) {
                                statusValue = "busyOnDelivery";
                            }
                            if (text.deliveryState.includes("Return")) {
                                statusValue = "busyOnReturn";
                            }
                            if (text.deliveryState.includes("Transfer")) {
                                statusValue = "busyOnTransfer";
                            }
                        }
                        return (
                            <Tag data-testid="courierStatus">
                                <Badge
                                    data-testid="courierStatus_badge"
                                    data-testvalue={Boolean(text.deliveryState || text.status)}
                                    color={courierStatusColors[text.deliveryState || text.status]}
                                />
                                {isConstantExist(mapCourierStatuses, statusValue)
                                    ? t(
                                          getConstant(mapCourierStatuses, statusValue)
                                              .translation_key,
                                          {
                                              ns: "mapCourierStatuses"
                                          }
                                      )
                                    : "-"}
                            </Tag>
                        );
                    }}
                />
                <Column
                    title={
                        <>
                            {t("fields.onboardingStatus", {ns: "common"})}
                            <br />
                            <span
                                style={{
                                    borderTop: "1px solid #00000029",
                                    paddingTop: "2px"
                                }}
                            >
                                {" "}
                                İşe Alım Alt Durumu
                            </span>
                        </>
                    }
                    dataIndex="onboardingStatus"
                    render={(onboardingStatus, courier) => (
                        <>
                            <Tag data-testid="onboardingStatus">
                                {renderOnboardingStatus({
                                    onboardingStatus,
                                    isApplicationRejected: courier?.isApplicationRejected
                                })}
                            </Tag>
                            <br />
                            <Tag data-testid="onboardingSubStatus">
                                {renderOnboardingSubStatus({
                                    onboardingSubStatus: courier?.onboardingSubStatus,
                                    isApplicationRejected: courier?.isApplicationRejected,
                                    onboardingStatus: courier?.onboardingStatus
                                })}
                            </Tag>
                        </>
                    )}
                />
                {/*    <Column
                    title="Cüzdan Durumu"
                    dataIndex="hasWallet"
                    render={hasWallet => <span>{hasWallet ? "Var" : "Yok"}</span>}
                /> */}
                {callStatus !== "notCalled" && (
                    <Column
                        title={
                            <>
                                Son Arama Tarihi
                                <br />
                                <span style={{borderTop: "1px solid #00000029", paddingTop: "2px"}}>
                                    Son Arama Durumu
                                </span>
                            </>
                        }
                        dataIndex={["lastCallRecord", "createdAt"]}
                        render={(createdAt, row) => (
                            <>
                                <span>
                                    {createdAt ? moment(createdAt).format("DD.MM.YYYY HH:mm") : "-"}
                                </span>
                                <br />
                                <span>
                                    {courierCallStatusMap[row.lastCallRecord.callStatus] ||
                                        row.lastCallRecord.callStatus ||
                                        "-"}
                                </span>
                            </>
                        )}
                    />
                )}
            </TableContainer>
        </div>
    ));
};
